import React, { type SyntheticEvent } from 'react';
import { useTranslation } from '@/app/components/translations/Translation';
import { FooterButton, FooterContainer, type FooterLayout } from './styled';

type Props = {
  applyText?: string;
  handleApply: (e: SyntheticEvent) => void;
  isApplyDisabled?: boolean;
  isApplyLoading?: boolean;
  clearText?: string;
  handleClear?: (e: SyntheticEvent) => void;
  isClearDisabled?: boolean;
  sticky?: boolean;
  showShadow?: boolean;
  layout?: FooterLayout;
} & React.HTMLAttributes<HTMLDivElement>;

const BasicModalFooterV2 = ({
  applyText,
  handleApply,
  isApplyDisabled,
  isApplyLoading,
  clearText,
  handleClear,
  isClearDisabled,
  sticky,
  showShadow,
  layout,
  ...rest
}: Props) => {
  const { t } = useTranslation();
  const isAligned = layout === 'right' || layout === 'left' || layout === 'centered';

  return (
    <FooterContainer hasClear={!!handleClear} $sticky={sticky} $showShadow={showShadow} $layout={layout} {...rest}>
      {handleClear && (
        <FooterButton
          appearance="ghost"
          size="large"
          $hugsLabel={isAligned}
          onClick={handleClear}
          disabled={isClearDisabled}
        >
          {clearText || t('vacation.oss.filters.clear')}
        </FooterButton>
      )}
      {handleApply && (
        <FooterButton
          size="large"
          onClick={handleApply}
          disabled={isApplyDisabled || isApplyLoading}
          loading={isApplyLoading}
          loadingAriaLabel={t('vacation.oss.components.searchfilters.main.loading')}
        >
          {applyText || t('vacation.oss.filters.apply')}
        </FooterButton>
      )}
    </FooterContainer>
  );
};

export type { FooterLayout } from './styled';
export default BasicModalFooterV2;
